import { useSuspenseQuery } from '@tanstack/react-query';
import { getGame } from '~/api';
import { GameDetailData } from '~/types';
import { MINUTE } from '~/constants';
import missionGameKey from './missionGameKey';

const useGetGameDetailQuery = (request: { game_id: number }) => {
  return useSuspenseQuery({
    queryKey: missionGameKey.getGame(request),
    queryFn: () => getGame(request),
    select: ({ data, status }) => {
      return data as GameDetailData;
    },
    staleTime: 30 * MINUTE,
  });
};

export default useGetGameDetailQuery;
